<template>
  <el-form
    ref="form"
    :rules="rules"
    :model="model"
    label-width="140px"
    label-position="right"
  >
    <el-form-item
      label="Nombre"
      prop="name"
    >
      <el-input
        v-model="model.name"
      />
    </el-form-item>
    <el-form-item
      label="Descripción"
      prop="description"
    >
      <wysiwyg
        v-model="model.description"
        :options="editorOptions"
      />
      <span class="input-helper">Esta descripción aparecera en la portada de la evaluación</span>
    </el-form-item>
    <el-form-item
      label="Área"
      prop="division"
    >
      <el-select
        v-model="model.division"
      >
        <el-option
          v-for="division of divisions"
          :key="division.name"
          :label="division.name"
          :value="division.name"
        />
      </el-select>
    </el-form-item>

    <el-form-item
      label="Tipo"
      prop="onlyMainBranches"
    >
      <el-switch
        v-model="model.onlyMainBranches"
        active-text="Matriz"
        inactive-text="Todas"
      />
      <span class="input-helper">Seleccione si este tipo de layout aplicara a todas las sucursales o solamente será asignadas a las sucursales de tipo matriz</span>
    </el-form-item>
    <el-form-item
      label="Tipo de sucursal"
      prop="dealerTypes"
    >
      <el-select
        v-model="model.dealerTypes"
        multiple
      >
        <el-option
          v-for="type of branchTypes"
          :key="type.name"
          :label="type.name"
          :value="type.name"
        />
      </el-select>
    </el-form-item>

    <el-form-item label="Estatus">
      <el-radio-group v-model="model.status">
        <el-radio-button
          label="published"
        >
          Publicado
        </el-radio-button>
        <el-radio-button
          label="unpublished"
        >
          Borrador
        </el-radio-button>
      </el-radio-group>
    </el-form-item>
  </el-form>
</template>

<script>
import Layout from './layout.model'
import { mapActions } from 'vuex'

export default {
  name: 'LayoutsForm',
  components: {},
  props: {
    old: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  data () {
    return {
      model: Layout.model(),
      rules: Layout.rules,
      editorOptions: {
        hideModules: {
          justifyLeft: true,
          justifyCenter: true,
          justifyRight: true,
          headings: true,
          link: true,
          code: true,
          orderedList: true,
          unorderedList: true,
          image: true,
          table: true,
          removeFormat: true
        }
      }
    }
  },
  computed: {
    divisions () {
      return this.$store.getters['divisions/items']
    },
    branchTypes () {
      return this.$store.getters['branchTypes/items']
    }
  },
  mounted () {
    this.model = Object.assign({}, this.model, this.old)
  },
  methods: {
    ...mapActions('layouts', ['save', 'query']),
    onSubmit () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.save(this.model)
            .then(response => {
              this.$message.success('El layout se ha creado con éxito')
              this.query().then(() => {
                this.$router.push({ name: 'layouts' })
              })
            })
            .catch(error => {
              this.$notify.error({
                title: 'Error en el servidor',
                message: 'Hubo un error al tratar de guardar la forma'
              })
              return Promise.reject(error)
            })
        } else {
          this.$notify.error({
            title: 'Verifica la forma',
            message:
              'Por favor, revisa lo errores que se indican dentro de la forma.'
          })
          return false
        }
      })
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/modules/layouts/layouts-form.vue